import React, {useEffect, useState} from 'react'
import { Dropdown, Grid, Input, Button, Icon } from 'semantic-ui-react'
import {useForm, Controller} from "react-hook-form"
import FacebookData from "../Sections/FacebookData"
import './style.css'

const FACEBOOK_WEBHOOK = "https://api.axc.ae/webhook/b1acf1f9-ffab-4131-9379-7bfb7cea29fe";

const DEFAULT_FACEBOOK_FORM_VALUES = {
    form_id: '',
    responsible: '',
    Ad_Project: '',
    Ad_Language: '',
    source_detail: '',
    marker: '',
    tags: []
}

const normalizeFormId = (value) => {
    if (value === undefined || value === null || value === '') {
        return '';
    }

    const cleanedValue = value.toString().trim();

    if (!/^\d+$/.test(cleanedValue)) {
        throw new Error('Form ID must contain only digits');
    }

    return cleanedValue;
}

const normalizeWebhookRows = (payload) => {
    let parsedPayload = payload;

    if (typeof parsedPayload === 'string') {
        try {
            parsedPayload = JSON.parse(parsedPayload);
        } catch (error) {
            return [];
        }
    }

    const candidates = [
        parsedPayload,
        parsedPayload?.body,
        parsedPayload?.data,
        parsedPayload?.rows,
        parsedPayload?.result,
        parsedPayload?.items,
        parsedPayload?.json,
        parsedPayload?.[0]?.json,
        parsedPayload?.[0]?.body,
        parsedPayload?.[0]?.data
    ];

    const rows = candidates.find(candidate => Array.isArray(candidate));

    return Array.isArray(rows)
        ? rows
            .map(row => row?.json || row?.body || row)
            .filter(row => row && Object.keys(row).length > 0)
        : [];
}

const readWebhookResponse = async (response) => {
    const text = await response.text();

    if (!text) {
        return {message: 'done'};
    }

    return JSON.parse(text);
}

const FB = () => {
    const {
        control,
        handleSubmit,
        reset
    } = useForm({
        defaultValues: DEFAULT_FACEBOOK_FORM_VALUES
    })

    const [projects, setProject] = useState([])
    const [language, setLanguage] = useState([])
    const [responsible, setResponsible] = useState([])
    const [tags, setTags] = useState([])
    const [responseMessage, setResponseMessage] = useState('');
    const [lastCreatedFormId, setLastCreatedFormId] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    async function adProject(){
        const response = await fetch('https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1568907438');
        const data = await response.json();
        setProject(data.result?.[0]?.LIST || [])
    }

    async function adLang(){
        const response = await fetch('https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1553165368131');
        const data = await response.json();
        setLanguage(data.result?.[0]?.LIST || [])
    }

    async function adResponsible(){
        const response = await fetch('https://crm.axcap.ae/local/webhooks/getUserIdName.php?api_key=UPmcMSpk86SLPprv');
        const data = await response.json();
        setResponsible(data)
    }

    async function adTags(){
        let start = 0;
        let allTags = [];

        while (start !== null) {
            const response = await fetch(`https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/lists.element.get?IBLOCK_TYPE_ID=lists&IBLOCK_ID=189&ELEMENT_ORDER%5BID%5D=ASC&start=${start}`);
            const data = await response.json();

            allTags = allTags.concat(data.result || []);
            start = data.next ?? null;
        }

        setTags(allTags)
    }
    
    useEffect(() => {
        adProject();
        adLang();
        adResponsible();
        adTags();
    }, [])

    const transformProject = projects.map(project => ({
        key: project.ID,
        text: project.VALUE,
        value: project.ID
    }))

    const transformLanguage = language.map(languageItem => ({
        key: languageItem.ID,
        text: languageItem.VALUE,
        value: languageItem.ID
    }))

    const transformResponsible = responsible.map(responsibleItem => ({
        key: responsibleItem.ID,
        text: responsibleItem.NAME,
        value: responsibleItem.ID
    }))
    transformResponsible.push({key: 1, text: 'AX CAPITAL', value: '1'})

    const transformTags = tags.map(tag => ({
        key: tag.ID,
        text: tag.NAME,
        value: tag.ID
    }))

    const onSubmit = async (fields) => {
        if (isSubmitting) {
            return;
        }

        if (!fields.form_id?.toString().trim()) {
            setResponseMessage({message: 'Form ID is required'});
            setLastCreatedFormId('');
            return;
        }

        setIsSubmitting(true);
        setResponseMessage('');
        setLastCreatedFormId('');

        try {
            const preparedFields = {
                ...fields,
                form_id: normalizeFormId(fields.form_id)
            };

            const duplicateResponse = await fetch(FACEBOOK_WEBHOOK, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify({
                    source: "facebook",
                    action: "checkDuplicate",
                    fields: {
                        form_id: preparedFields.form_id
                    }
                })
            });
            const duplicateData = await readWebhookResponse(duplicateResponse);
            const duplicates = normalizeWebhookRows(duplicateData);

            if (duplicates.length > 0) {
                setResponseMessage({message: `Duplicate form. Existing Form ID: ${duplicates[0].form_id}`});
                return;
            }

            const response = await fetch(FACEBOOK_WEBHOOK, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify({
                    source: "facebook",
                    action: "create",
                    fields: preparedFields
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await readWebhookResponse(response);
            setResponseMessage(data);
            setLastCreatedFormId(preparedFields.form_id || '');
            reset(DEFAULT_FACEBOOK_FORM_VALUES);
            setRefreshKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error('Error:', error);
            setResponseMessage(error.message || 'An error occurred');
            setLastCreatedFormId('');
        } finally {
            setIsSubmitting(false);
        }
    }

    return(
        <>
            <h1 className='title'>- Facebook -</h1>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container columns='equal' className='grid-form'>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>Form ID</span>
                                <Controller
                                    name='form_id'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input type='text' placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div className='item'>
                                <span>Responsible</span>
                                <Controller
                                    name='responsible'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='select responsible'
                                            fluid
                                            search
                                            selection
                                            options={transformResponsible}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>Project</span>
                                <Controller
                                    name='Ad_Project'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Project'
                                            fluid
                                            search
                                            selection
                                            options={transformProject}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div className='item'>
                                <span>Language</span>
                                <Controller
                                    name='Ad_Language'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Language'
                                            fluid
                                            search
                                            selection
                                            options={transformLanguage}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>Source Details</span>
                                <Controller
                                    name='source_detail'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div className='item'>
                                <span>Marker</span>
                                <Controller
                                    name='marker'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>Tags</span>
                                <Controller
                                    name='tags'
                                    defaultValue={[]}
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Tags'
                                            fluid
                                            multiple
                                            search
                                            selection
                                            options={transformTags}
                                            value={value || []}
                                            onOpen={adTags}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column />
                    </Grid.Row>
                    <Button animated className='fb-button' type='submit' disabled={isSubmitting} loading={isSubmitting}>
                        <Button.Content visible>Create Integration</Button.Content>
                        <Button.Content hidden>
                            <Icon name='arrow right' />
                        </Button.Content>
                    </Button>
                </Grid>
            </form>
            {responseMessage && (
                <div className="reponse-message">
                    <p>
                        {typeof responseMessage === 'string'
                            ? responseMessage
                            : `Response: ${responseMessage.message || 'done'} | Form ID: ${responseMessage.id || responseMessage.form_id || lastCreatedFormId}`}
                    </p>
                </div>
            )}
            <FacebookData refreshKey={refreshKey}/>
        </>
    )
}

export default FB;
